<div id="side-nav" class="d-none d-md-flex">
    <div id="items-container">
        <app-sidenav-item *ngFor="let item of menu.items" [item]="item"></app-sidenav-item>
    </div>
    <div class="card" style="background-color: #f8f8f8; text-align: center; padding: 16px 16px 16px 16px;">
        {{ 'menues.support' | translate }}
        <i style="padding-top: 8px">support@nead.se</i>
    </div>
</div>
